// LOCAL-timezone date helpers. toISOString() returns UTC — using it for "today"
// makes users east of UTC (like UAE, UTC+4) see YESTERDAY between 00:00-04:00 local.
// en-CA locale produces YYYY-MM-DD in the user's LOCAL timezone. Always use this.

export const localFmt = (d) => d.toLocaleDateString("en-CA");
export const localToday = () => new Date().toLocaleDateString("en-CA");

export function localOffsetDays(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toLocaleDateString("en-CA");
}
